import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Success from "./pages/Success";
import DiagnosticTest from "./pages/DiagnosticTest";
import Admin from "./pages/Admin";

export default function AppRouter({ onOpenModal }) {
  return (
    <Routes>
      <Route path="/" element={<Home onOpenModal={onOpenModal} />} />
      <Route path="/success" element={<Success onOpenModal={onOpenModal} />} />
      <Route
        path="/diagnostic"
        element={<DiagnosticTest onOpenModal={onOpenModal} />}
      />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}
